import { useTranslation } from "react-i18next";

// Why home was reached without the user leaving: the call moved to another
// tab, or it failed while they were browsing away from its room.
export function HomeNotice({ moved, ended }: { moved?: boolean; ended?: string }) {
  const { t } = useTranslation();
  if (!moved && !ended) return null;
  return (
    <p className="mx-5 -mt-6 mb-6 text-center text-sm text-muted-foreground" role="status">
      {moved
        ? t("home.connectionMoved")
        : `${t("home.callEnded")} ${t(`home.errors.${ended}`, { defaultValue: t("home.errors.default") })}`}
    </p>
  );
}
